import ShowerForm from "./Form";
import { Button } from "@material-ui/core";
import { Reply } from "@material-ui/icons";
import React from "react";
import Classic from "./ShowerTemplates/Classic";
import Wreath from "./ShowerTemplates/Wreath";
import Sakura from "./ShowerTemplates/Sakura";
import GoldDots from "./ShowerTemplates/GoldDots";
import GoldGlitter from "./ShowerTemplates/GoldGlitter";
import MarsalaFloral from "./ShowerTemplates/MarsalaFloral";
import SilverGlitter from "./ShowerTemplates/SilverGlitter";
import ModernMinimalist from "./ShowerTemplates/ModernMinimalist";
import BotanicalSage from "./ShowerTemplates/BotanicalSage";
import GildedArch from "./ShowerTemplates/GildedArch";
import CustomInvitation from "./ShowerTemplates/CustomInvitation";
import FormHeader from "../assets/resources/FormHeader";
import CustomShowerForm from "./CustomForm";
import "./ShowerTemplates/CSS/Medias.css";

var converter = require('number-to-words');

class SideBySide extends React.Component {
   
  constructor(props) {
    super();
    // eslint-disable-next-line no-extend-native
    String.prototype.capitalize = function () {
      return this.charAt(0).toUpperCase() + this.slice(1);
    }
    this.template = props.template;
    this.requestLine1 = "You're Cordially invited to a"
    this.requestLine2 = "Bridal Shower honoring"
    this.womanName = 'Juliet'
    this.manName = ''
    this.day = "Monday"
    this.date = 'the Twenty-ninth of November'
    this.year = "Two thousand and twenty one"
    this.time = "Five thirty in the evening"
    this.venue = "Kol Yaakov"
    this.venueForMaps = ''
    this.venueAddress = "1703 McDonald Avenue"
    this.cityState = "Brooklyn, New York"
    this.phone = " 1 (347) 280-3596"
    this.link = 'https://www.google.com/maps/search/?api=1&query=kol+yaakov'
    this.footerMessage1 = `We're Registered At:`
    this.footerMessage2 = `Wishing Well, Timeless Table, and Macy's`
    this.endingNote = 'Join us in our happiness!'
    this.changed = false;
    this.brideInitial = this.womanName.charAt(0).capitalize();
    this.groomInitial =  this.manName.charAt(0).capitalize();
    this.reqObject =
    {
      envelopeColor:"black",
      isSideBySide:true,
      loadingActive:false,
      customDesign:'',
      template: this.template,
      requestLine1: this.requestLine1,
      requestLine2: this.requestLine2,
      womanName: this.womanName,
      manName: this.manName,
      day: this.day,
      date: this.date,
      year: this.year,
      time: this.time,
      brideInitial : this.womanName.charAt(0).capitalize(),
      groomInitial :  this.manName.charAt(0).capitalize(),
      venue: this.venue,
      venueForMaps: this.venueForMaps,
      venueAddress: this.venueAddress,
      cityState: this.cityState,
      phone: this.phone,
      link: this.link,
      footerMessage1: this.footerMessage1,
      footerMessage2: this.footerMessage2,
      endingNote: this.endingNote,
      changed: this.changed,
      invitationType: "Shower"
    }
    this.handleReqObject = this.handleReqObject.bind(this);
  }
  ChooseTemplate() {
    window.location.reload();
  }
  getHours(date) {
    return date.getHours() % 12 || 12;
  }
  handleReqObject = (value) => {
    // eslint-disable-next-line
    String.prototype.capitalize = function () {
      return this.charAt(0).toUpperCase() + this.slice(1);
    }


    var days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

    var d = new Date(value.eventDate);

    var dayName = days[d.getDay()];
    var date = converter.toOrdinal(d.getUTCDate());
    console.log(value.eventDate)
    this.day = dayName;
    this.date = "the " + date + " of " + d.toLocaleString('default', { month: 'long' });
    this.year = converter.toWords(d.getFullYear()).split(',').join(' and ').capitalize();
    var hours = d.getHours();
    var ampm = hours >= 12 ? 'pm' : 'am';
    var timeOfDay = ampm.includes("am") ? "morning" : "evening";
    this.time = converter.toWords(this.getHours(d)) + " " + converter.toWords(d.getMinutes()) + " in the " + timeOfDay;
    var newTime = this.time.replace("zero", "o'clock");

    this.reqObject = {
      template: this.template,
      requestLine1: value.requestLine1,
      requestLine2: value.requestLine2,
      womanName: value.womanName,
      manName: value.manName,
       dayName :days[d.getDay()],
       date : "the " + date + " of " + d.toLocaleString('default', { month: 'long' }),
      
      day :dayName,
      //date : "the " + date + " of " + d.toLocaleString('default', { month: 'long' }),
      year : converter.toWords(d.getFullYear()).split(',').join(' and ').capitalize(),
      hours : d.getHours(),
      timeOfDay : ampm.includes("am") ? "morning" : "evening",
      time : newTime,
      loadingActive: value.loadingActive,
      venue: value.venue,
      envelopeColor:value.envelopeColor,
      venueForMaps: value.venueForMaps,
      venueAddress: value.venueAddress,
      cityState: value.cityState,
      phone: value.phone,
      link: value.link,
      footerMessage1: value.footerMessage1,
      footerMessage2: value.footerMessage2,
      endingNote: value.endingNote,
      changed: value.changed,
      invitationType: "Shower",
      fontFamily: value.fontFamily,
      fontSize: value.fontSize
    }

    this.setState((prevState, props) => ({
      changed: !value.changed,

    }));
    console.log(this.changed)
    console.log(this.reqObject.brideParents + 'ppppp')
  }

  render() {
    return (
      <div id="side-by-side-page" style = {{margin: 0,  padding: 0,width:"100%"}} >

        <FormHeader />
        <Button variant="contained" onClick={() => this.ChooseTemplate()} style={{ backgroundColor: "#1DAEE0", color: "white", margin:"10px"}} size="large" startIcon={<Reply />}>CHOOSE ANOTHER TEMPLATE</Button>
        <div className="text-center" >
          <div className="form-row" style={{ margin: 0 }}>
            <div className="col-md-5"></div>
            <div className="col-md text-center" style={{ padding: "8px" }}>
              <p style={{ color: "#444", fontStyle: "italic", fontSize: "1rem", margin: 0, fontWeight: 500 }}>
                The watermark will be removed once payment is complete.
              </p>
            </div>
          </div>
          <div className="form-row">
            <div className="form-group col-md-5">
           { this.template === 'custom' ?
            <CustomShowerForm reqObject={this.reqObject} handleReqObject={this.handleReqObject} template={this.template} />
            :<ShowerForm reqObject={this.reqObject} handleReqObject={this.handleReqObject} template={this.template} />
           
            }
            </div>
            {this.template === 'classic' ?
              <div id="letters" className="col-md classic-shower-style myDiv">
                <div className="watermark"></div>
                <Classic reqObject={this.reqObject} handleReqObject={this.handleReqObject} isSideBySide={true} />
              </div>
            :
            this.template === 'goldDots' ?
              <div id="letters" className="col-md goldDots-shower-style myDiv">
                <div className="watermark"></div>
                <GoldDots reqObject={this.reqObject} handleReqObject={this.handleReqObject} isSideBySide={true} />
              </div>
            :
            this.template === 'goldGlitter' ?
              <div id="letters" className="col-md goldGlitter-shower-style myDiv">
                <div className="watermark"></div>
                <GoldGlitter reqObject={this.reqObject} handleReqObject={this.handleReqObject} isSideBySide={true} />
              </div>
            :
            this.template === 'wreath' ?
              <div className="col-md wreath-shower-style myDiv">
                <div className="watermark"></div>
                <Wreath reqObject={this.reqObject} handleReqObject={this.handleReqObject} isSideBySide={true} />
              </div>
            :
            this.template === 'modernMinimalist' ?
              <div id="letters" className="col-md modernMinimalist-shower-style">
                <ModernMinimalist reqObject={this.reqObject} handleReqObject={this.handleReqObject} isSideBySide={true} />
              </div>
            :
            this.template === 'botanicalSage' ?
              <div id="letters" className="col-md botanicalSage-shower-style">
                <BotanicalSage reqObject={this.reqObject} handleReqObject={this.handleReqObject} isSideBySide={true} />
              </div>
            :
            this.template === 'gildedArch' ?
              <div id="letters" className="col-md gildedArch-shower-style">
                <GildedArch reqObject={this.reqObject} handleReqObject={this.handleReqObject} isSideBySide={true} />
              </div>
            :
            this.template === 'silverGlitter' ?
              <div id="letters" className="col-md silverGlitter-shower-style myDiv">
                <div className="watermark"></div>
                <SilverGlitter reqObject={this.reqObject} handleReqObject={this.handleReqObject} isSideBySide={true} />
              </div>
            :
            this.template === 'marsalaFloral' ?
              <div className="col-md marsalaFloral-shower-style myDiv">
                <div className="watermark"></div>
                <MarsalaFloral reqObject={this.reqObject} handleReqObject={this.handleReqObject} isSideBySide={true} isSakura={true} />
              </div>
            :
            this.template === 'custom' ?
              <div className="col-md sakura-shower-style myDiv">
                <div className="watermark"></div>
                <CustomInvitation reqObject={this.reqObject} handleReqObject={this.handleReqObject} isSideBySide={true} isSakura={true} />
              </div>
            :
              <div className="col-md sakura-shower-style myDiv">
                <div className="watermark"></div>
                <Sakura reqObject={this.reqObject} handleReqObject={this.handleReqObject} isSideBySide={true} isSakura={true} />
              </div>
            }
          </div>
        </div>
        
      </div>
    );
  }
}

export default SideBySide;